import i18n from 'i18next'
import koTranslations from './assets/locale/ko/translate.json'
import jpTranslations from './assets/locale/jp/translate.json'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
	.use(LanguageDetector) // 브라우저 언어 감지기 추가
	.use(initReactI18next)
	.init({
		resources: {
			ko: { translation: koTranslations },
			ja: { translation: jpTranslations }, // jp -> ja (브라우저 표준 코드)
		},
		// lng 제거 - LanguageDetector가 자동으로 감지하도록
		fallbackLng: 'ko', // 기본 언어 설정
		detection: {
			// 언어 감지 설정
			order: ['localStorage', 'sessionStorage', 'navigator'], // navigator 추가
			lookupLocalStorage: 'i18nextLng',
			lookupSessionStorage: 'i18nextLng',
			caches: ['localStorage', 'sessionStorage'],
			excludeCacheFor: ['cimode'], // 개발 모드 제외
		},
		interpolation: {
			escapeValue: false, // xss 방지
		},
	})

export default i18n
